import styled from 'styled-components';

const VideoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;

  iframe {
    width: 100%;
    height: 406px;
    margin: 0;

    @media (min-width: 768px) {
      height: 406px;
    }

    @media (min-width: 990px) {
      height: 506px;
    }
  }
`;
VideoWrapper.displayName = 'VideoWrapper';

export default VideoWrapper;
